import { type PropsWithChildren } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { isTruthy } from "../../../utils/isTruthy";

type Props = {
  label?: string;
  className?: string;
  dataTestId: string;
  isFormType?: boolean;
  isDivider?: boolean;
  isConstrained?: boolean;
  isCompact?: boolean;
};

export function FormGroup({
  children,
  label,
  className,
  dataTestId,
  isFormType = false,
  isDivider = false,
  isConstrained = false,
  isCompact = false,
}: PropsWithChildren<Props>) {
  const hasWideSpacing = isFormType && !isCompact;

  return (
    <div
      className={cnTwMerge("w-full", className, {
        " pt-8 border-t border-divider": isDivider,
      })}
    >
      {isTruthy(label) ? (
        <div className="body-semi-large-medium text-text/primary mb-4">
          {label}
        </div>
      ) : null}
      <div
        className={cnTwMerge({
          "space-y-4": !hasWideSpacing,
          "space-y-12": hasWideSpacing,
          "md:max-w-custom-question": isConstrained,
          "w-full": !isConstrained,
        })}
        data-testid={`form-section-${dataTestId}`}
      >
        {children}
      </div>
    </div>
  );
}

export function FormGroupChild({ children }: PropsWithChildren<Props>) {
  return <div className="pl-0 sm:pl-8 space-y-4">{children}</div>;
}
